import VMwareMigrationCompletion from "./VMwareMigrationCompletion";

export default VMwareMigrationCompletion;
